export default __webpack_public_path__ + "static/media/Layer_26.3276f8ee.svg";